/* Wand product world runtime (gallery, variants, add-on, buy, sticky bar,
   style cards, reveal, video controls). Depends on window.evCart (ev-core.js). */
(function () {
  'use strict';
  var money = function (cents) {
    var fmt = (window.evMoneyFormat || '${{amount}}');
    var v = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  };

  function Gallery(root) {
    var track = root.querySelector('.ev-wg__track');
    if (!track) return null;
    var slides = [].slice.call(track.children);
    var thumbs = [].slice.call(root.querySelectorAll('.ev-wg__thumb'));
    var dots = [].slice.call(root.querySelectorAll('.ev-wg__dot'));
    var idx = 0;
    function mark(i) {
      idx = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      slides.forEach(function (s, k) {
        var v = s.querySelector('video');
        if (!v) return;
        if (k === i) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause();
      });
      var t = thumbs[i];
      if (t && t.parentNode.scrollWidth > t.parentNode.clientWidth) t.parentNode.scrollTo({ left: t.offsetLeft - 40, behavior: 'smooth' });
    }
    function go(i, instant) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: instant ? 'auto' : 'smooth' });
      mark(i);
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== idx) mark(i);
      });
    }, { passive: true });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(thumbs.indexOf(t)); }); });
    var prev = root.querySelector('[data-ev-prev]'), next = root.querySelector('[data-ev-next]');
    prev && prev.addEventListener('click', function () { go(idx - 1); });
    next && next.addEventListener('click', function () { go(idx + 1); });
    mark(0);
    return {
      /* on the storefront a style shows its infographic first; the variant image itself
         (used by shopping feeds) stays the clean photo without text */
      toVariant: function (v) {
        var key = 'wand-' + String(v.title || '').toLowerCase().split(' ')[0] + '-in-box';
        for (var n = 0; n < slides.length; n++) if ((slides[n].dataset.mediaName || '').indexOf(key) === 0) return this.toMedia(slides[n].dataset.mediaId);
        return this.toMedia(v.media);
      },
      toMedia: function (mediaId) {
        if (!mediaId) return;
        var k = -1;
        for (var n = 0; n < slides.length; n++) if (slides[n].dataset.mediaId === String(mediaId)) k = n;
        if (k < 0) return;
        /* keep the action video right after the picked style's photo */
        var vi = -1;
        for (var m = 0; m < slides.length; m++) if (slides[m].dataset.mediaId === 'video') vi = m;
        if (vi > -1 && vi !== k + 1) {
          var vs = slides[vi], vt = thumbs[vi];
          var target = slides[k];
          target.after(vs);
          if (vt && thumbs[k]) thumbs[k].after(vt);
          slides = [].slice.call(track.children);
          thumbs = [].slice.call(root.querySelectorAll('.ev-wg__thumb'));
          k = slides.indexOf(target);
        }
        go(k, false);
      }
    };
  }

  function Buy(root) {
    var dataEl = root.querySelector('[data-ev-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var gallery = Gallery(root.querySelector('.ev-wg'));
    var form = root.querySelector('[data-ev-form]');
    var btn = root.querySelector('[data-ev-add]');
    var btnLabel = btn && btn.querySelector('[data-ev-add-label]');
    var nameEls = root.querySelectorAll('[data-ev-vname]');
    var nowEl = root.querySelector('[data-ev-now]');
    var wasEl = root.querySelector('[data-ev-was]');
    var saveEl = root.querySelector('[data-ev-save]');
    var qtyIn = root.querySelector('[data-ev-qty]');
    var addon = root.querySelector('[data-ev-addon]');
    var addonIn = addon && addon.querySelector('input');
    var err = root.querySelector('[data-ev-error]');
    var sticky = document.querySelector('[data-ev-sticky]');
    var current = variants.find(function (v) { return v.selected; }) || variants[0];

    /* buy more, save more: 1-3 single wands, each with its own style */
    var qb = root.querySelector('[data-ev-qb]');
    var qbSlots = qb && qb.querySelector('[data-ev-qb-slots]');
    var singleIds = [].map.call(root.querySelectorAll('.ev-vp:not(.ev-vp--sets):not(.ev-vp--qb) input[name="ev-variant"]'), function (i) { return Number(i.value); });
    var singles = variants.filter(function (v) { return singleIds.indexOf(v.id) > -1; });
    var qbN = 1;
    var noSlots = !!(qb && qb.hasAttribute('data-no-slots'));
    function isSingle(v) { return singleIds.length ? singleIds.indexOf(v.id) > -1 : !!qb; }
    function qbPct(n) { if (!qb || n < 2) return 0; return Number(n >= 4 ? qb.dataset.pct4 : n === 3 ? qb.dataset.pct3 : qb.dataset.pct2) || 0; }
    function qtyVal() { return Math.max(1, Math.min((singleIds.length && isSingle(current)) ? 10 : 99, Number(qtyIn ? qtyIn.value : 1) || 1)); }
    function syncQty() { if (qtyIn) qtyIn.value = qtyVal(); qbN = isSingle(current) ? qtyVal() : 1; buildSlots(); render(); }
    /* Shopify rounds a percentage discount down to the cent, per unit */
    function unitAfter(price, n) { return price - Math.floor(price * qbPct(n) / 100); }
    function slotSelects() { return qbSlots ? [].slice.call(qbSlots.querySelectorAll('select')) : []; }
    function buildSlots() {
      if (!qbSlots) return;
      var prev = slotSelects().map(function (s) { return Number(s.value); });
      qbSlots.innerHTML = '';
      if (noSlots || qbN < 2 || !isSingle(current)) { qbSlots.hidden = true; return; }
      var used = [current.id];
      for (var i = 0; i < qbN; i++) {
        var pick = i === 0 ? current.id : (prev[i] || (singles.find(function (v) { return used.indexOf(v.id) < 0 && v.available; }) || current).id);
        used.push(pick);
        var wrap = document.createElement('label');
        wrap.className = 'ev-qb__slot';
        var sel = document.createElement('select');
        sel.setAttribute('aria-label', 'Wand ' + (i + 1) + ' style');
        sel.dataset.slot = i;
        singles.forEach(function (v) {
          var o = document.createElement('option');
          o.value = v.id; o.textContent = v.title; o.disabled = !v.available;
          if (v.id === pick) o.selected = true;
          sel.appendChild(o);
        });
        wrap.innerHTML = '<span>Wand ' + (i + 1) + '</span>';
        wrap.appendChild(sel);
        qbSlots.appendChild(wrap);
      }
      qbSlots.style.setProperty('--slots', Math.min(qbN, 4));
      qbSlots.hidden = false;
    }

    function render() {
      nameEls.forEach(function (n) { n.textContent = current.title; });
      var bundle = qb && isSingle(current) && qbN > 1;
      if (qb) qb.hidden = !isSingle(current);
      var qtyWrap = qtyIn && qtyIn.closest('.ev-qty');
      var cardsUI = !!(qb && qb.classList.contains('ev-qb--cards'));
      if (qtyWrap) qtyWrap.hidden = cardsUI;
      if (qb) [].forEach.call(qb.querySelectorAll('[data-qb-n]'), function (c) { var k = Number(c.dataset.qbN); var on = cardsUI ? k === Math.min(qbN, 4) : bundle && (k === qbN || (k === 4 && qbN >= 4)); c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      var unitNow = bundle ? unitAfter(current.price, qbN) : current.price;
      var n = bundle ? qbN : 1;
      var setQty = isSingle(current) ? 1 : qtyVal();
      if (nowEl) nowEl.textContent = money(unitNow * n * setQty);
      var baseWas = current.compare > current.price ? current.compare : current.price;
      var off = baseWas * n > unitNow * n ? Math.round((1 - unitNow / baseWas) * 100) : 0;
      if (wasEl) { wasEl.textContent = off ? money(baseWas * n * setQty) : ''; wasEl.hidden = !off; }
      if (saveEl) { saveEl.textContent = off ? 'Save ' + off + '%' : ''; saveEl.hidden = !off; }
      if (btn) {
        btn.disabled = !current.available;
        if (btnLabel) btnLabel.textContent = current.available ? (btn.dataset.label || 'Add to cart') + (btn.dataset.showPrice === 'true' ? ' · ' + money(unitNow * n * setQty) : '') : 'Sold out';
      }
      if (sticky) {
        var sp = sticky.querySelector('[data-ev-sticky-price]');
        if (sp) sp.innerHTML = money(current.price) + (off ? '<s>' + money(current.compare) + '</s>' : '');
        var si = sticky.querySelector('img');
        if (si && current.image) si.src = current.image;
      }
      document.querySelectorAll('[data-ev-pay-id]').forEach(function (i) { i.value = current.id; });
      var url = new URL(window.location.href);
      url.searchParams.set('variant', current.id);
      history.replaceState(history.state, '', url.toString());
    }

    root.addEventListener('change', function (e) {
      if (e.target.name === 'ev-variant') {
        var id = Number(e.target.value);
        var wasSingle = isSingle(current);
        current = variants.find(function (v) { return v.id === id; }) || current;
        if (qtyIn && wasSingle !== isSingle(current)) qtyIn.value = 1;
        syncQty();
        if (gallery) gallery.toVariant(current);
      }
      if (addonIn && e.target === addonIn) addon.classList.toggle('is-on', addonIn.checked);
      if (e.target.matches && e.target.matches('[data-ev-qb-slots] select')) {
        if (e.target.dataset.slot === '0') {
          var inp = root.querySelector('input[name="ev-variant"][value="' + e.target.value + '"]');
          if (inp) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
        }
      }
    });

    root.querySelectorAll('[data-ev-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var cap = (singleIds.length && isSingle(current)) ? 10 : 99;
        var v = Math.max(1, Math.min(cap, Number(qtyIn.value || 1) + Number(b.dataset.evStep)));
        qtyIn.value = v; syncQty();
      });
    });
    qtyIn && qtyIn.addEventListener('input', syncQty);
    qb && qb.addEventListener('click', function (e) {
      var c = e.target.closest && e.target.closest('[data-qb-n]');
      if (!c || !qtyIn) return;
      var k = Number(c.dataset.qbN);
      qtyIn.value = (k === 4 && qbN >= 4) ? qbN : k;
      syncQty();
    });

    function add() {
      if (!current.available || !window.evCart) return;
      if (err) err.textContent = '';
      btn && btn.setAttribute('aria-busy', 'true');
      var items;
      if (qb && !noSlots && isSingle(current) && qbN > 1 && slotSelects().length === qbN) {
        var counts = {}, order = [];
        slotSelects().forEach(function (s) { var id = Number(s.value); if (!counts[id]) { counts[id] = 0; order.push(id); } counts[id]++; });
        items = order.map(function (id) { return { id: id, quantity: counts[id] }; });
      } else {
        items = [{ id: current.id, quantity: Math.max(1, Number(qtyIn ? qtyIn.value : 1)) }];
      }
      if (addonIn && addonIn.checked && addonIn.value) items.push({ id: Number(addonIn.value), quantity: 1 });
      window.evCart.add(items).catch(function (e) {
        if (err) err.textContent = (e && (e.description || e.message)) || 'Could not add to cart. Please try again.';
      }).then(function () { btn && btn.removeAttribute('aria-busy'); });
    }
    form && form.addEventListener('submit', function (e) { e.preventDefault(); add(); });

    /* style cards elsewhere on the page select a variant */
    document.addEventListener('click', function (e) {
      var card = e.target.closest && e.target.closest('[data-ev-pick]');
      if (!card) return;
      e.preventDefault();
      var name = card.getAttribute('data-ev-pick').toLowerCase();
      var match = variants.find(function (v) { return v.title.toLowerCase() === name; }) || variants.find(function (v) { return v.title.toLowerCase().indexOf(name) === 0; });
      if (match) {
        var input = root.querySelector('input[name="ev-variant"][value="' + match.id + '"]');
        if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-ev-to-buy]');
      if (!t) return;
      e.preventDefault();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    /* sticky bar */
    if (sticky && btn) {
      var sb = sticky.querySelector('button');
      sb && sb.addEventListener('click', add);
      var io = new IntersectionObserver(function (en) {
        var below = en[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', !en[0].isIntersecting && below);
      });
      io.observe(btn);
    }
    render();
  }

  function reveal() {
    var els = document.querySelectorAll('.ev-reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { threshold: .12 });
    els.forEach(function (e) { io.observe(e); });
  }

  function unboxing() {
    document.querySelectorAll('[data-ev-unbox]').forEach(function (box) {
      var b = box.querySelector('.ev-unbox__play'), v = box.querySelector('video');
      if (!b || !v) return;
      b.addEventListener('click', function () { box.classList.add('is-playing'); v.controls = true; v.muted = false; v.play(); });
    });
  }

  function reviewSound() {
    document.addEventListener('click', function (e) {
      var s = e.target.closest && e.target.closest('[data-ev-sound]');
      if (!s) return;
      var v = s.parentNode.querySelector('video');
      if (!v) return;
      document.querySelectorAll('.ev-vr video').forEach(function (o) { if (o !== v) { o.muted = true; o.closest('.ev-vr__media').classList.remove('is-loud'); } });
      v.muted = !v.muted;
      if (!v.muted) { v.currentTime = 0; v.play(); }
      s.closest('.ev-vr__media').classList.toggle('is-loud', !v.muted);
    });
  }

  function boot() {
    document.body.classList.add('ev-wand-page');
    document.querySelectorAll('[data-ev-wand]').forEach(Buy);
    reveal(); unboxing(); reviewSound();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
